<template>
    <v-container class="d-flex align-center justify-center">
        <v-card class="complete__steps_card" elevation="3">
            <v-container>
                <v-row justify="center">
                    <img 
                        class="img" 
                        alt="check" 
                        src="/images/Check.png"
                        
                    />
                </v-row>
                <v-row  justify="center">
                    <h2 class="mb-2 text-center">Estamos generando tus informes</h2>
                </v-row>
                <v-row justify="center" class="text-center">
                    <p>Esto puede tardar unos minutos. Cuando estén listos te los enviaremos a tu correo.</p>
                    <strong>Revisa los informes generados registrándote en nuestra plataforma.</strong>
                </v-row>
                <v-row justify="center">
                    <v-btn class="mt-7 text-none font-weight-bold" color="primary" @click="navigateTo(url + 'cliente/register')" >
                        Regístrate
                    </v-btn>
                </v-row>
                <v-row justify="center" align="baseline">
                    <p class="my-5 mx-2">
                        Si ya tienes cuenta sólo debes
                    </p>
                    <v-btn @click="navigateTo(url + 'cliente/login')" class="mt-7 text-none font-weight-bold" color="primary" variant="plain" style=" padding: 0 !important">iniciar sesión</v-btn>
                </v-row>
            </v-container>
    
        </v-card>
    </v-container>
    <v-dialog v-model="showStatusModal2" max-width="550">
        <v-card class="rounded-xl" style="line-height: normal;">
            <v-card-title class="headline text-center font-weight-bold text-h6">
                <v-img
                    :src="require('@/assets/warning.png')"
                    contain
                    max-width="100"
                    class="mx-auto mb-4"
                />
                <strong class="header-label">Importante</strong>
            </v-card-title>

            <v-card-text style="text-align: center;">
            <label style="font-size:14px;">
                Actualmente, 
                algunos servicios externos están presentando intermitencias, por lo que la generación del informe podría tardar un poco más de lo normal.        
            </label>
            </v-card-text>
            <v-card-text class="info-box">
                <v-icon class="info-icon">mdi-information</v-icon>
                <span class="info-text">
                    <strong style="font-size:14px;font-weight:700;">
                        Una vez emitido el informe, este te llegará por correo.  O bien lo puedes revisar directamente en la plataforma de Checkempresa.
                    </strong>
                </span>
            </v-card-text>
            <v-card-text style="text-align: center;">
            <label style="font-size:14px;">
                Lamentamos los inconvenientes y queremos que sepas que estamos monitoreando la situación.<br><br>
                Gracias por tu  comprensión.
            </label>
            </v-card-text> 
            <!---->
            <v-card-actions class="justify-center">
            <v-btn @click="cerrarInformativo" class="modal_button mb-3 text-none font-weight-bold" variant="flat" color="primary">
                Entiendo
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from '@/api';
import { mapGetters,  } from 'vuex';
export default {
    name: 'Step_4',
    data(){
        return {
            url: '',
            isLeaving: false,
            showStatusModal2 : false,
        }
    },
    computed: {
        ...mapGetters('alert', ['getAlert']),
    },
    async mounted(){
        if(!this.getAlert){
            this.showStatusModal2 = true
        }
        const {status, data} = await api.getURLBackend();
        if(status === 1) this.url = data; 
        
        window.addEventListener("beforeunload", this.handlePageUnload);
    },
    methods:{
        handlePageUnload(){
            if (this.isLeaving) return;
            
            this.isLeaving = true;
            this.$store.dispatch("cart/restartFlow");
            this.$store.dispatch("payment/resetCheckout");
        },
        navigateTo(url) {
            this.isLeaving = true;
            window.location.href = url;
        },
        cerrarInformativo(){
            this.showStatusModal2 = false
        }
    },

    beforeUnmount(){
        window.removeEventListener("beforeunload", this.handlePageUnload);
    }
}
</script>

<style lang="scss" scoped>
.img{
    max-width: 82px;
    max-height: 82px;
    margin: auto;
}
.info-text {
        font-size: 16px;
        font-weight: 500;
    }

    .modal_button {
        font-size:16px;
    }
.info-icon {
        font-size: 24px;
        margin-right: 12px;
        color: #004CDD;                  
    }
.info-box {
        display: flex;
        align-items: center;
        border: 1px solid #004CDD;        
        background-color: #D3E1FD;        
        border-radius: 8px;               
        padding: 16px;
        color: #004CDD;                   
        width:90%;
        margin-left:4%;    
    }
</style>